import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({ baseURL: BASE_URL, timeout: 8000 });
const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getGroupsMeta = (token) =>
  api.get('/api/groups/meta', authHeader(token)).then(r => r.data);

export const getGroupYears = (token) =>
  api.get('/api/groups/years', authHeader(token)).then(r => r.data);

export const listGroups = (token, year) =>
  api.get('/api/groups', { ...authHeader(token), params: year ? { year } : {} }).then(r => r.data);

export const createGroup = (token, { name, leader, application, sessionDate, sessionType, members }) =>
  api.post(
    '/api/groups',
    {
      name,
      leader: leader || null,
      application,
      session_date: sessionDate || null,
      session_type: sessionType,
      members: members || [],
    },
    authHeader(token)
  ).then(r => r.data);

export const updateGroup = (token, groupId, patch) => {
  const body = {};
  if (patch.name !== undefined) body.name = patch.name;
  if (patch.leader !== undefined) body.leader = patch.leader;
  if (patch.application !== undefined) body.application = patch.application;
  if (patch.sessionDate !== undefined) body.session_date = patch.sessionDate;
  if (patch.sessionType !== undefined) body.session_type = patch.sessionType;
  if (patch.progress !== undefined) body.progress = patch.progress;
  if (patch.members !== undefined) body.members = patch.members;

  return api.put(`/api/groups/${groupId}`, body, authHeader(token)).then(r => r.data);
};

export const deleteGroup = (token, groupId) =>
  api.delete(`/api/groups/${groupId}`, authHeader(token)).then(r => r.data);

export const getErrorMessage = (error, fallback = "Une erreur est survenue.") =>
  error?.response?.data?.detail || fallback;